import React from "react";
import "./OpenBets.css"; // Include the CSS in a separate file or use inline styles
import "../../../src/App.css";
import Header from "../header/Header";
import Footer from "../Footer/Footer";
import { CiSearch } from "react-icons/ci";
import 'bootstrap/dist/css/bootstrap.min.css';
import { getAllBets } from '../../redux/slice/openBet/openBetSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import Appconfig from '../../config/config';
import axios from 'axios';
import Helper from "../../helper";
import { useNavigate } from 'react-router-dom';
import { Table } from "antd";
import ExposureHeader from '../ExposureHeader/ExposureHeader';
import ScrollGames from "../ScrollGames/ScrollGames";
import SideMenu from "../SideMenu/SideMenu";
import { Outlet } from "react-router-dom";

function OpenBets(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = Helper(); // get login user details
  const openbets = useSelector((state) => state.bets); // Use selector to access state
  const [fancyBets, setFancyBets] = useState([]);
  const [matchBets, setMatchBets] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  // console.log('matchBets', matchBets);
  // console.log('fancyBets', fancyBets);
  const [showMenu, setShowMenu] = useState(false); // <-- Add this
    // Handler to toggle menu
  const handleToggleMenu = () => setShowMenu((prev) => !prev);
  const [eventType, setEventType] = useState(undefined); // or your default

  useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= 991);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

  const getOpenBetsByEvent = async () => {
    dispatch(getAllBets({
      user_id: userInfo?._id,
    }))
  }

  useEffect(() => {
    getOpenBetsByEvent()
  }, [])

  useEffect(() => {
    if (openbets?.bets?.length > 0) {
      let openBetsData = openbets?.bets;
      let fancyOpenBets = openBetsData?.filter(fancy => fancy.betting_type == "Fancy");
      let matchOpenBets = openBetsData?.filter(match => match.betting_type == "Match");
      setFancyBets(fancyOpenBets);
      setMatchBets(matchOpenBets);
    }
  }, [openbets])

  const columns = [
    {
      title: 'Event Name',
      dataIndex: 'event_name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.event_name}</span>
        </>
      ),
    },
    {
      title: 'Market Type',
      dataIndex: 'market_name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.market_name}</span>
        </>
      ),
    },
    {
      title: 'Selection',
      dataIndex: 'runner_name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.runner_name}</span>
        </>
      ),
    },
    {
      title: 'Bet Type',
      dataIndex: 'is_back',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.is_back ? 'Back' : 'Lay'}</span>
        </>
      ),
    },
    {
      title: 'Stack',
      dataIndex: 'stake',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.stake}</span>
        </>
      ),
    },

    {
      title: 'Round ID',
      dataIndex: 'betting_id',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?._id}</span>
        </>
      ),
    },
    {
      title: 'Place Time',
      dataIndex: 'createdAt',
      sorter: true,
      render: (_, record) => (
        <>
          <span>
            {new Date(record?.createdAt).toLocaleString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })}
          </span>
        </>
      ),
    },
  ];


  const columnFancy = [
    {
      title: 'Event Name',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.event_name}</span>
        </>
      ),
      width: '20%',
    },
    {
      title: 'Market Type',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.market_name}</span>
        </>
      ),
      width: '20%',
    },
    {
      title: 'Selection',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.runner_name}</span>
        </>
      ),
      width: '20%',
    },
    {
      title: 'Bet Type',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.is_back ? 'Back' : 'Lay'}</span>
        </>
      ),
      width: '20%',
    },
    {
      title: 'Stack',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.stake}</span>
        </>
      ),
      width: '20%',
    },

    {
      title: 'Round ID',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?._id}</span>
        </>
      ),
      width: '20%',
    },
    {
      title: 'Place Time',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>
            {new Date(record?.createdAt).toLocaleString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })}
          </span>
        </>
      ),
      width: '20%',
    },
  ];

  // if (isMobile){
    if (!userInfo) {
      // Not logged in: show the sidebar code
      return (
        <aside
          title="Menu2"
          id="rightDeskSideBar"
          className="lg:flex p-0 overflow-y-auto sticky top-0 h-[calc(100vh-110px)]"
          style={{ maxWidth: "350px"}}
        >
          <div style={{ width: "350px"}} className="flex p-2 overflow-x-hidden relative no-scrollbar border flex-col rounded-lg bg-bg_color_primary" >
            <div className="w-full flex flex-col gap-y-1 py-2">
              <div className="w-full flex items-center gap-1">
                <div className="flex gap-1 w-3/4 rounded-lg p-0.5 border">
                  <button className="text-xs w-full capitalize whitespace-nowrap rounded p-2 bg-bg_color_primary text-black">
                    Betslip
                  </button>
                  <button className="text-xs w-full capitalize whitespace-nowrap rounded p-2 bg-bg_brand_secondary text-text_color_primary2">
                    Open Bets
                  </button>
                </div>
              </div>
              <h4 className="text-sm font-lato text-center py-4 text-text_color_primary1 font-normal">
                Please login to see your open bets.
                <span className="bg-bg_text_brand_primary bg-clip-text text-transparent cursor-pointer hover:underline">
                  Login
                </span>
              </h4>
            </div>
          </div>
        </aside>
      );
    }
  // }


  return (
    <>
      {!props.hideHeadings && (
        <>
          <div className="open-bet">
            <p className="open-para">
              <span>Open Bets</span>
            </p>
            <p className="odds">
              <span>Match Odds</span>
            </p>
          </div>
        </>
      )}
      <div className="table-container bg-bg_color_primary">
        <Table
          columns={columns}
          dataSource={matchBets}
          pagination={true}
          bordered={true}
          rowClassName={(record) =>
            record.is_back
              ? "bet-back-row"
              : "bet-lay-row"
          }
        />
      </div>
      {!props.hideHeadings && (
        <p className="odds">
          <span>Session</span>
        </p>
      )}
      <div className="table-container bg-bg_color_primary mt-4">
        <Table
          columns={columnFancy}
          dataSource={fancyBets}
          pagination={true}
          bordered={true}
          rowClassName={(record) =>
            record.is_back
              ? "bet-back-row"
              : "bet-lay-row"
          }
        />
      </div>
    </>
  );
}

export default OpenBets;
